import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';

export const TypeCustomer = 'customer';
export const TypeLocation = 'location';

export default function DuplicateItemsDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const [locations, setLocations] = useState([]);
    const [customers, setCustomers] = useState([]);
    const { t } = useTranslation();

    const convertItem = useCallback(
        (item, type) => {
            return {
                id: item.id,
                name: item.name,
                businessId: item.businessId,
                portfolioName: item.portfolio.name,
                duplicateType: type,
                onActivePortfolio: item.portfolio.id === userProfile.selectedPortfolioId,
            };
        },
        [userProfile.selectedPortfolioId]
    );

    const getFlattenList = useCallback(
        (duplicateData) => {
            let ret = [];
            if (duplicateData.duplicatesByName && duplicateData.duplicatesByName.length > 0) {
                ret = duplicateData.duplicatesByName.map((item) => convertItem(item, 'name'));
            }
            if (duplicateData.duplicatesByBusinessId && duplicateData.duplicatesByBusinessId.length > 0) {
                ret = ret.concat(duplicateData.duplicatesByBusinessId.map((item) => convertItem(item, 'businessid')));
            }
            return ret;
        },
        [convertItem]
    );

    useEffect(() => {
        if (props.items) {
            if (props.items.locationDuplicates) {
                setLocations(getFlattenList(props.items.locationDuplicates));
            }
            if (props.items.customerDuplicates) {
                setCustomers(getFlattenList(props.items.customerDuplicates));
            }
        }
    }, [props.items, getFlattenList]);

    const onCancel = () => {
        props.cancel();
    };

    const onItemClick = (id, type) => {
        props.history.push(type === TypeCustomer ? `/customers/${id}` : `/locations/${id}`);
    };

    return (
        <Dialog open={props.open} fullWidth={true} maxWidth={'md'} fullScreen={fullScreen}>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <h5>
                            {t('general.customers')} ({customers.length})
                        </h5>
                        {customers.map((item) => (
                            <Grid
                                item
                                xs={12}
                                onClick={() => {
                                    if (item.onActivePortfolio) onItemClick(item.id, TypeCustomer);
                                }}
                                key={item.id}
                                sx={{ cursor: 'pointer', mb: '0.25em' }}
                                name={item.name}>
                                <Chip label={item.portfolioName} />
                                &nbsp;
                                <span style={item.duplicateType === 'name' ? { backgroundColor: 'lightgrey' } : undefined}>
                                    {item.name ? item.name : '<ei nimeä>'}
                                </span>
                                <span style={item.duplicateType === 'businessid' ? { backgroundColor: 'lightgrey' } : undefined}>
                                    ({item.businessId})&nbsp;
                                </span>
                                {item.onActivePortfolio && <OpenInNewIcon sx={{ verticalAlign: 'middle' }} />}
                            </Grid>
                        ))}
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                        <h5>
                            {t('general.locations')} ({locations.length})
                        </h5>
                        {locations.map((item) => (
                            <Grid
                                item
                                xs={12}
                                onClick={() => {
                                    if (item.onActivePortfolio) onItemClick(item.id, TypeLocation);
                                }}
                                key={item.id}
                                sx={{ cursor: 'pointer', mb: '0.25em' }}
                                name={item.name}>
                                <Chip label={item.portfolioName} />
                                &nbsp;
                                <span style={item.duplicateType === 'name' ? { backgroundColor: 'lightgrey' } : undefined}>
                                    {item.name ? item.name : '<ei nimeä>'}
                                </span>
                                <span style={item.duplicateType === 'businessid' ? { backgroundColor: 'lightgrey' } : undefined}>
                                    ({item.businessId})&nbsp;
                                </span>
                                {item.onActivePortfolio && <OpenInNewIcon sx={{ verticalAlign: 'middle' }} />}
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }} name="duplicate-view-close" onClick={onCancel}>
                    {t('buttons.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
